import { useEffect } from 'react';
import { useRouteHelper } from './use-route-helper';
import { autorun, when } from 'mobx';

import { useStore } from 'core/store';
import { get, policyTypes } from 'core/helpers/lookups';
import { brandConstants } from 'brand-config';

const getPolicyType = get(policyTypes);

export const useTabText = () => {
  const {
    inPolicyRoute,
    inOfferEditRoute,
    inUWFormRoute,
    inOfferCheckoutRoute,
    inCustomerRoute,
    inNewQuoteRoute,
    inToolsRoutes,
    inSearchOffers,
    inSearchCustomers,
    inSearchPolicies,
    inAgencyPortal,
    inSignInRoute,
    inBranchPlusPolicy
  } = useRouteHelper();
  const { offer: offerStore, account: accountStore, branchPlus: branchPlusStore } = useStore();
  const { policies: policesStore } = accountStore;
  const { policy: policyStore } = policesStore;

  return useEffect(() =>
    autorun(async () => {
      if (inOfferEditRoute || inOfferCheckoutRoute || inUWFormRoute) {
        await when(() => !offerStore?.isLoading && offerStore?.primaryNamedInsured);
        if (offerStore?.primaryNamedInsured) {
          document.title = `${offerStore?.primaryNamedInsured} - Quote`;
        } else {
          document.title = 'Quote';
        }
      } else if (inNewQuoteRoute) {
        document.title = 'New Quote';
      } else if (inPolicyRoute) {
        await when(() => !accountStore?.accountLoading && !policyStore?.loading && policyStore?.policy?.policyType);
        if (accountStore?.fname && accountStore?.lname) {
          if (policyStore?.policyType) {
            document.title = `${accountStore.fname} ${accountStore.lname} - ${getPolicyType(policyStore?.policy?.policyType)} Policy`;
          } else {
            document.title = `${accountStore?.fname} ${accountStore?.lname} - Policy`;
          }
        } else {
          document.title = 'Policy';
        }
      } else if (inBranchPlusPolicy) {
        await when(() => !branchPlusStore?.loading && branchPlusStore?.branchPlusPolicy);
        if (branchPlusStore?.branchPlusPolicy && branchPlusStore?.branchPlusPolicy?.customer) {
          document.title = `${branchPlusStore?.branchPlusPolicy?.customer?.firstName} ${branchPlusStore?.branchPlusPolicy?.customer?.lastName} - ${brandConstants.SHORT_NAME} Plus Policy`;
        } else {
          document.title = `${brandConstants.SHORT_NAME} Plus Policy`;
        }
      } else if (inCustomerRoute) {
        await when(() => !accountStore?.accountLoading);
        if (accountStore?.fname && accountStore?.lname) {
          document.title = `${accountStore?.fname} ${accountStore?.lname} - Member`;
        } else {
          document.title = 'Member';
        }
      } else if (inToolsRoutes) {
        document.title = 'Internal Tools';
      } else if (inSearchOffers) {
        document.title = 'Search Quotes';
      } else if (inSearchCustomers) {
        document.title = 'Search Members';
      } else if (inSearchPolicies) {
        document.title = 'Search Policies';
      } else if (inAgencyPortal) {
        document.title = 'Agency Portal';
      } else if (inSignInRoute) {
        document.title = 'Sign In';
      } else {
        document.title = `${brandConstants.SHORT_NAME} Staff App`;
      }
    })
  );
};
